import { createSelector } from "@ngrx/store";
import { IAppState } from "../state/app.state";
import { ICartState } from "../state/cart.state";

const selectCartState = (state: IAppState) => state.cartState;

export const selectCart = createSelector(selectCartState, (state: ICartState) => state.cart);
export const selectCartOpen = createSelector(selectCartState, (state: ICartState) => state.isCartOpen);
export const selectDropShipCost = createSelector(selectCartState, (state: ICartState) => state.dropShipCost);
export const selectCartItemAlerts = createSelector(selectCartState, (state:ICartState) => state.cartItemAlerts)